// extracted by mini-css-extract-plugin
export default {"form":"styles_form__6zRi1","button":"styles_button__kFZv8"};